import type { Component } from "svelte"
import Chat from "./chat.svelte"
import Audit from "./audit.svelte"
import OneLine from "./one_line.svelte"
import Calendar from "./calendar.svelte"
import Live from "./live.svelte"
import Drop from "./drop.svelte"
import Voice from "./voice.svelte"
import Callback from "./callback.svelte"
import Pass from "./pass.svelte"
import Tasks from "./tasks.svelte"

export const concepts: { title: string; component: Component }[] = [
  { title: "Conversation", component: Chat },
  { title: "Cost audit", component: Audit },
  { title: "One line", component: OneLine },
  { title: "Calendar first", component: Calendar },
  { title: "Live availability", component: Live },
  { title: "Drop your files", component: Drop },
  { title: "Voice note", component: Voice },
  { title: "Call me back", component: Callback },
  { title: "Boarding pass", component: Pass },
  { title: "Your tasks", component: Tasks },
]
